export const BASE_URL = 'https://api.pks.rs'
// export const BASE_URL = 'http://pks.ohdstaging.com'
export const API_BASE_URL = `${BASE_URL}/public-api`
export const MEDIA_BASE_URL = `${BASE_URL}/storage/assets/`

export const ERROR_DATA_UNAVAILABLE = 'Error data unavailable.'
export const ERROR_CONNECTION_ISSUE = 'Error connection issue.'
